<template>
    <div class="app">
        <AppHeader />
        <div class="app-body">
            <Sidebar :navItems="nav" />
            <main class="main">
                <breadcrumb :list="list" />
                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import
{
    mapGetters,
    mapActions
}
from 'vuex'
import
{
    Header as AppHeader,
    Sidebar,
    Footer as AppFooter,
    Breadcrumb
}
from '../components/admin/'

export default
{
    name: 'full',
    components:
    {
        AppHeader,
        Sidebar,
        AppFooter,
        Breadcrumb
    },
    data()
    {
        var me = this;
        return {
            nav: []
        }
    },
    created()
    {
        if (this.langInitialized)
        {
            this.initMenu();
        }
    },
    methods:
    {
        initMenu()
        {
            var me = this;

            this.nav = [
            {
                name: me.$i18n.t('DASHBOARD'),
                url: '/admin/dashboard',
                visible: true,
                icon: 'home'
            },
            {
                name: me.$i18n.t('SITECONTENT'),
                icon: 'file',
                visible: true,
                children: [
                {
                    name: me.$i18n.t('WIKICATEGORIES'),
                    url: '/admin/sitecontent/wikicategories',
                    visible: (me.globals.acl.WikiCategory && me.globals.acl.WikiCategory.insertAction) ? true : false,
                    icon: 'sitemap'
                },
                {
                    name: me.$i18n.t('WIKITEMPLATES'),
                    url: '/admin/sitecontent/wikitemplates',
                    visible: (me.globals.acl.WikiTemplates && me.globals.acl.WikiTemplates.insertAction) ? true : false,
                    icon: 'file-code'
                },
                {
                    name: me.$i18n.t('NEWWIKI'),
                    url: '/admin/sitecontent/newwiki',
                    visible: (me.globals.acl.Wiki && me.globals.acl.Wiki.insertAction) ? true : false,
                    icon: 'file-import'
                },
                {
                    name: me.$i18n.t('ARTICLES'),
                    url: '/admin/sitecontent/wikis',
                    visible: (me.globals.acl.Wiki && me.globals.acl.Wiki.insertAction) ? true : false,
                    icon: 'file'
                }]
            },
            {
                name: me.$i18n.t('KYC'),
                icon: 'user',
                visible: true,
                children: [
                {
                    name: me.$i18n.t('FACEDETECTION'),
                    url: '/admin/kyc/facedetection',
                    visible: (me.globals.acl.FaceDetection && me.globals.acl.FaceDetection.insertAction) ? true : false,
                    icon: 'user'
                },
                {
                    name: me.$i18n.t('FACEDETECTIONPROPS'),
                    url: '/admin/kyc/facedetectionprops',
                    visible: (me.globals.acl.SiteProps && me.globals.acl.SiteProps.insertAction) ? true : false,
                    icon: 'wrench'
                }]
            },
            {
                name: me.$i18n.t('SYSTEM'),
                icon: 'cog',
                visible: true,
                children: [
                    {
                        name: me.$i18n.t('ACL'),
                        url: '/admin/system/acl',
                        visible: (me.globals.acl.AclPrivilages && me.globals.acl.AclPrivilages.insertRow && me.globals.acl.AclPrivilages.insertRow.instantiate) ? true : false,
                        icon: 'lock'
                    },
                    {
                        name: me.$i18n.t('TRANSLATOR'),
                        url: '/admin/system/translator',
                        visible: (me.globals.acl.Translator && me.globals.acl.Translator.instantiate) ? true : false,
                        icon: 'flag'
                    },
                    {
                        name: me.$i18n.t('LANGUAGES'),
                        url: '/admin/system/languages',
                        visible: (me.globals.acl.TransLang && me.globals.acl.TransLang.instantiate) ? true : false,
                        icon: 'globe'
                    },
                    {
                        name: me.$i18n.t('SITEPROPS'),
                        url: '/admin/system/siteprops',
                        visible: (me.globals.acl.SiteProps && me.globals.acl.SiteProps.instantiate) ? true : false,
                        icon: 'wrench'
                    },
                    {
                        name: me.$i18n.t('EMAILTEMPLATES'),
                        url: '/admin/system/emailtemplates',
                        visible: (me.globals.acl.EmailTemplates && me.globals.acl.EmailTemplates.instantiate) ? true : false,
                        icon: 'envelope'
                    },
                    {
                        name: me.$i18n.t('USERCOMPANIES'),
                        url: '/admin/system/usercompanies',
                        visible: (me.globals.acl.UserCompanies && me.globals.acl.UserCompanies.instantiate) ? true : false,
                        icon: 'building'
                    },
                    {
                        name: me.$i18n.t('USERS'),
                        url: '/admin/system/users',
                        visible: (me.globals.acl.Users && me.globals.acl.Users.instantiate) ? true : false,
                        icon: 'user'
                    },
                    {
                        name: me.$i18n.t('GENERATOR'),
                        url: '/admin/system/generator',
                        visible: (me.globals.acl.Users && me.globals.acl.Users.instantiate) ? true : false,
                        icon: 'rocket'
                    } //GENERATORINSERT
                ]
            }]
        }
    },
    watch:
    {
        translation()
        {
            this.initMenu();
        },
        langInitialized()
        {
            this.initMenu();
        }
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'langInitialized',
            'translation'
        ]),
        name()
        {
            return this.$route.name
        },
        list()
        {
            return this.$route.matched
        }
    }
}
</script>
